// 公用js，建议使用IIFE（立即执行函数）
(function() {
  if ($('.last-page').length > 0) {
    var lastHref = $('.last-page').attr('href');
    var tempHref1 = lastHref.split('-')[0];
    var tempHref2 = lastHref.split('-')[1];
    var lastPageNum = parseInt(tempHref2.split('.')[0]);
    $('.yn-pagination .last-page').after(
      '<span class="page-num total-page-num" >共' +
        lastPageNum +
        '页</span><span class="page-num go-page"  style="cursor: pointer;">转到</span><span class="page-num" style="padding-left:5px;padding-right:5px;"><input name="pageinput" type="text" class="page-input" style="border:none; width:50px;  outline: none; text-align:center;"></span>'
    );
    $('.yn-pagination .go-page').on('click', function () {
      var pageNum = parseInt($('.page-input').val());

      if (pageNum === '') {
        alert('请输入页码！');
        return false;
      }
      if (isNaN(pageNum) || pageNum <= 0 || pageNum > lastPageNum) {
        alert('请输入正确页码！');
        return false;
      }
      toHref = tempHref1 + '-' + pageNum + '.html';
      window.location.href = toHref;
    });
  }

  function renews(cname, cweb, curl) {
    tuneone = $('body[data-page-type="index"]')
      .find('.cn:contains("' + cname + '")')
      .parents('.module-name')
      .siblings('.module-content');
    tuneone.find('.news-list').load(curl + ' .news-list li', function() {
      initialtotal = tuneone.find('li').length;
      var nlist = new Array();
      for (var i = 0; i < initialtotal; i++) {
        nlist[i] = new Array();
        for (var j = 0; j < 4; j++) {
          nlist[i][j] = '';
        }
      }

      tuneone.find('li').each(function() {
        eqnum = $(this).index();

        nlist[eqnum][0] = $(this)
          .find('a')
          .attr('title');
        nlist[eqnum][1] = $(this)
          .find('a')
          .attr('href');
        nlist[eqnum][2] = $(this)
          .find('a')
          .attr('target');
        nlist[eqnum][3] = $(this)
          .find('span')
          .text();
        nlist[eqnum][1].substring(0, 1) == '.'
          ? (nlist[eqnum][1] = nlist[eqnum][1].substring(1))
          : (nlist[eqnum][1] = nlist[eqnum][1]);
      });

      nlist.sort(function(a, b) {
        return b[3] < a[3] ? -1 : 1;
      });

      var borntotal = 4;
      var bornlist = '';
      for (var m = 0; m < borntotal; m++) {
        bornlist =
          bornlist +
          '<li><a href="' +
          cweb +
          nlist[m][1] +
          '" title="' +
          nlist[m][0] +
          '" target="' +
          nlist[m][2] +
          '">' +
          nlist[m][0] +
          '</a> <span>' +
          nlist[m][3] +
          '</span></li>';
      }
      tuneone.find('.news-list').html(bornlist);
    });
  }

  renews('招生专题', '/zs', '/zs/index.html');
  // renews('教学管理','/jxgl/index.html');

  // 页面翻滚
  new WOW().init();
    // 数字滚动参数
    var options = {
      useEasing: true, // 过渡动画效果，默认ture
      useGrouping: false, // 千分位效果，例：1000->1,000。默认true
      separator: ',', // 使用千分位时分割符号
      decimal: '.', // 小数位分割符号
      prefix: '', // 前置符号
      suffix: '' // 后置符号，可汉字
    }
    var allHtmlContents = [];
    var timers = [];
    // 从dom中获取需要显示的数字
    $('.timer-num').each(function() {
      allHtmlContents.push(parseInt($(this).html()));
    });
  
    // 为每个dom设置一个实例
    allHtmlContents.forEach((v, i) => {
      var target = 'timer-num' + i;
      timers.push(new CountUp(target, 0, v, 0, 3, options));
    })
  
    // 启动动画
    function start(isRestart) {
      timers.forEach((timer) => {
        if (isRestart) {
          timer.reset();
        }
        timer.start();
      });
    }
  
    // 滚动到指定位置时执行动画
    $(window).scroll(function () {
      var numL = $('.timer-num-list').length;
      if (numL) {
        if ($(window).scrollTop() > ($(".timer-num-list").offset().top - $(window).height())) {
          start(false);
        }
      }
    })
    // 切换slider时重新执行动画
    var prevSlide = 0;
    $('.J_iconLink').on('afterChange', (event, slick, currentSlide, nextSlide) => {
      if (prevSlide !== currentSlide) {
        start(true);
        prevSlide = currentSlide;
      }
    });
})();

//# sourceMappingURL=module.js.map
